import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// env
import { environment } from 'src/environments/environment';

// custom enums
import { PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { CRUD_COMPONENT } from 'src/app/core/enums/global/crud-types';

// guards
import { VipAdsGuard } from 'src/app/core/guards/ads/vip-ads.guard';
import { IsAuthGuard } from 'src/app/core/guards/auth/is-auth.guard';
import { AdsResloveGuard } from 'src/app/core/guards/ads/resolve-guard';
import { IsAppOwner } from 'src/app/core/guards/auth/is-app-owner.guard';
import { ForcedStopGuard } from 'src/app/core/guards/ads/forced-stop.guard';
// import { AdsPackagesGuard } from 'src/app/core/guards/packages/ads-packages';
import { IsAdsOwnerGuard } from 'src/app/core/guards/ads/is-ads-owner.guard';
import { IsAdsVisitorGuard } from 'src/app/core/guards/ads/is-ads-visitor.guard';
import { DepositIsPaidGuard } from 'src/app/core/guards/ads/deposit-is-paid.guard';
import { IsAdsAvailableGuard } from 'src/app/core/guards/ads/is-ads-available.guard';
import { CompleteProfileGuard } from 'src/app/core/guards/ads/complete-profile.guard';
import { IsAdsRentDailyGuard } from 'src/app/core/guards/ads/is-ads -rent-daily.guard';
import { IsAdsOwnerHasMarketPlaceGuard } from 'src/app/core/guards/ads/is-ads-owner-hasMarketPlace.guard';

// resolvers
import { banksResolver } from './resolvers/banks.resolver';
import { companiesResolver } from './resolvers/companies.resolver';
import { paymentPlansResolver } from './resolvers/payment-plans.resolver';
import { regaDataResolver } from 'src/app/core/guards/ads/rega-data.resolver';
import { bundledAdsResolver } from 'src/app/core/guards/ads/bundled-ads.resolver';
import { afterSaleServicesResolver } from './resolvers/after-sales-services.resolver';
import { regionsResolver } from 'src/app/core/guards/shared/resolve/regions.resolver';
import { categoriesResolver } from 'src/app/core/guards/shared/resolve/categories.resolver';
import { IsBundledAdsAllowEditFromResolve } from 'src/app/core/guards/ads/is-bundled-ads-allow-edit-form.guard';

// main component
import { AdsManagementComponent } from './ads-management.component';

// child components
import { BookingsComponent } from './bookings/bookings.component';
import { buildAdsComponent } from './build-ads/build-ads.component';

// shared components
import { ViewAdsComponent } from './shared.components/view-ads/view-ads.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { 
    path: '', component: AdsManagementComponent, 
    canActivateChild: [AdsResloveGuard],
    children: [
      // { 
      //   path: 'view-realty-request/:id' , component: ViewAdsComponent, canActivate: [
      //     // IsAdsAvailableGuard
      //   ],
      //   data: { 
      //     name: 'request',
      //     key: 'advertisement',
      //     endPoint: 'adsRequest',
      //     type: PRODUCT_TYPE.request,
      //   } 
      // },
      {
        path: 'view-realty-advertisement/:id' , component: ViewAdsComponent, 
        resolve: {
          rega: regaDataResolver,
          // bundledAds: bundledAdsResolver
        },
        data: {
          key: 'advertisement',
          name: 'advertisement',
          type: PRODUCT_TYPE.advertisement,
          endPoint: environment.endPointAds,
        }
      },
      {
        path: 'add-realty-advertisement' , component: buildAdsComponent, canActivate: [
          IsAppOwner,
          IsAuthGuard,
          ForcedStopGuard,
          // AdsPackagesGuard,
          CompleteProfileGuard,
        ],
        resolve: {
          banks: banksResolver,
          regions: regionsResolver,
          companies: companiesResolver,
          categories: categoriesResolver,
          paymentPlans: paymentPlansResolver,
          saleServices: afterSaleServicesResolver,          
        },        
        data: {
          title: 'إضافة عقار',
          label: 'إضافة عرض عقار',
          curd: CRUD_COMPONENT.create,
          type: PRODUCT_TYPE.advertisement,
        } 
      },
      {
        path: 'edit-realty-advertisement/:id' , component: buildAdsComponent, canActivate: [
          IsAppOwner,
          IsAuthGuard,
          IsAdsOwnerGuard,
          DepositIsPaidGuard,
          CompleteProfileGuard,
        ],
        resolve: {
          banks: banksResolver,
          rega: regaDataResolver,
          regions: regionsResolver,
          companies: companiesResolver,
          categories: categoriesResolver,          
          paymentPlans: paymentPlansResolver,
          saleServices: afterSaleServicesResolver,
          bundledAdFullEdit: IsBundledAdsAllowEditFromResolve
        },
        data: {
          title: 'تعديل عقار',
          label: 'تعديل عرض عقار',
          curd: CRUD_COMPONENT.update,
          type: PRODUCT_TYPE.advertisement,
        } 
      },      
      // {
      //   path: 'add-realty-vip-advertisement' , component: buildAdsComponent, canActivate: [
      //     IsAppOwner,
      //     IsAuthGuard,
      //     VipAdsGuard,
      //     ForcedStopGuard,
      //     // AdsPackagesGuard,
      //     CompleteProfileGuard,
      //   ],
      //   resolve: {
      //     banks: banksResolver,
      //     regions: regionsResolver,
      //     categories: categoriesResolver,          
      //     saleServices: afterSaleServicesResolver,
      //   },        
      //   data: {
      //     vipAds: true,
      //     title: 'إضافة عقار',
      //     label: 'إضافة اعلان خاص',
      //     curd: CRUD_COMPONENT.create,
      //     type: PRODUCT_TYPE.advertisement,
      //   } 
      // },      
      // {
      //   path: 'edit-realty-vip-advertisement/:id' , component: buildAdsComponent,
      //   canActivate: [
      //     IsAppOwner,
      //     IsAuthGuard,
      //     VipAdsGuard,
      //     IsAdsOwnerGuard,
      //     DepositIsPaidGuard,
      //     CompleteProfileGuard,
      //   ],
      //   resolve: {
      //     banks: banksResolver,
      //     rega: regaDataResolver,
      //     regions: regionsResolver,
      //     categories: categoriesResolver,          
      //     saleServices: afterSaleServicesResolver,
      //     bundledAdFullEdit: IsBundledAdsAllowEditFromResolve
      //   },
      //   data: {
      //     vipAds: true,
      //     title: 'تعديل عقار',
      //     label: 'تعديل عرض عقار خاص',
      //     curd: CRUD_COMPONENT.update,
      //     type: PRODUCT_TYPE.advertisement,
      //   } 
      // },      
      {
        path: 'bookings-realty/:id' , component: BookingsComponent,
        canActivate: [
          IsAuthGuard,
          IsAdsVisitorGuard,
          IsAdsAvailableGuard,
          IsAdsRentDailyGuard,
          CompleteProfileGuard,
          IsAdsOwnerHasMarketPlaceGuard
        ], 
        data: {
          type: PRODUCT_TYPE.advertisement,
        } 
      },
      { 
        path: 'realty-request',
        canActivate: [IsAuthGuard],
        loadChildren: () => import('./ads-request/ads-request.module').then(m => m.AdsRequestModule)
      },
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdsManagementRoutingModule { }
